import { Link } from "react-router-dom";

const HeroSection = ({ title, breadcrumb }) => {
  return (
    <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
            {title}
          </h1>
          <p className="text-black">
            <Link to={"/"}> Home </Link> {' > '} {breadcrumb}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
